import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useSelector, useDispatch } from "react-redux";
import { CheckoutContextProvider } from "vino/context";
import { setStep } from "store/vino/checkoutSlice";
import CustomerInformation from "./CustomerInformation";
import Payment from "./Payment";
import ShippingOptions from "./ShippingOptions";
import OrderSummary from "../OrderSummary";

const steps = [
	{
		id: 1,
		title: "Shipping Address",
	},
	{
		id: 2,
		title: "Shipping",
	},
	{
		id: 3,
		title: "Payment",
	},
];

const Checkout = () => {
	const dispatch = useDispatch();
	const activeStep = useSelector(({ vino }) => vino.checkout.step);

	const handleBack = () => {
		dispatch(setStep(activeStep - 1));
	};
	return (
		<CheckoutContextProvider>
			<div className="flex flex-wrap">
				<div className="w-3/5">
					<Stepper classes={{ root: "bg-transparent" }} activeStep={activeStep}>
						{steps.map((step) => {
							return (
								<Step key={step.id}>
									<StepLabel sx={{ cursor: "pointer!important" }}>
										{step.title}
									</StepLabel>
								</Step>
							);
						})}
					</Stepper>
					<div className="py-20">
						{activeStep === 1 && <CustomerInformation />}
						{activeStep === 2 && <ShippingOptions onBack={handleBack} />}
						{activeStep === 3 && <Payment onBack={handleBack} />}
					</div>
				</div>

				<div className="flex flex-col w-2/5 p-12 pt-0">
					<OrderSummary title='Order summary'/>
				</div>
			</div>
		</CheckoutContextProvider>
	);
};

export default Checkout;
